$.fn.randomize = function (selector) {
    var $elems = selector ? $(this).find(selector) : $(this).children(),
        $parents = $elems.parent();

    $parents.each(function () {
        $(this).children(selector).sort(function (childA, childB) {
            // * Prevent last slide from being reordered
            if ($(childB).index() !== $(this).children(selector).length - 1) {
                return Math.round(Math.random()) - 0.5;
            }
        }.bind(this)).detach().appendTo(this);
    });

    return this;
};



$(function () {

    $('[data-fancybox]').fancybox({
        afterShow: function () {
            $("video").on("ended", function () {
                $.fancybox.close();
            });
        },
        buttons: [
            "close"
        ]
    });


    $('form button[type="submit"]').click(function () {
        var c1 = $('input[name=neuigkeiten]').not(":checked").length;
        var c2 = $('input[name=plaetze]').not(":checked").length;

        if (c1 && c2) {
            $('input[name=neuigkeiten], input[name=plaetze]').prop('required', true);
            $('.checkbox').addClass('parsley-error');
        } else {
            $('input[name=neuigkeiten], input[name=plaetze]').prop('required', false);
            $('.checkbox').removeClass('parsley-error');
        }

        $('.checkbox--wrapper').removeClass('parsley-error-parent');
        $('.checkbox').each(function () {
            if ($(this).hasClass('parsley-error')) {
                $('.checkbox--wrapper').addClass('parsley-error-parent');
            }
        });

    });



    $('.header__home').bind('click', function () {
        playIntro();
    });

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        // console.log(scroll); 
        if (scroll > 700) {
            $('.topTop').addClass('show');
        } else {
            $('.topTop').removeClass('show');
        }
    });





    $(".topTop").click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
        return false;
    });

    function playIntro() {
        $('.header__home').addClass('small');
        $('.intro').addClass('hide');
        $('.header__home').unbind('click');

        $('.badge').addClass('show');

        setTimeout(function () {
            $('.intro').css('display', 'none');
            $('.header__home').css('display', 'none');
            $('.header__logo--small').css('opacity', 1);
            playSlideAnimation();
        }, 2000);

        let slideshow = $('.slideshow').randomize().slick({
            dots: true,
            infinite: true,
            speed: 800,
            fade: true,
            autoplay: false,
            autoplaySpeed: 5000
        });

        $(slideshow).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            if (!event.target.classList.contains('phone-slideshow')) {
                playSlideAnimation();
                resetSlideAnimation();
            }
        });
    }

    function playSlideAnimation() {
        $('.slick-active .bubble').delay(750).animate({ marginTop: '0%' }, { duration: 1000, easing: 'easeOutElastic' });
        $('.slick-active .img_2').delay(2500).animate({ opacity: '1' }, { duration: 800 });
    }

    function resetSlideAnimation() {
        $('.slide:not(".slick-active") .bubble').css('margin-top', '-50%');
        $('.slide:not(".slick-active") .img_2').css('opacity', '0');
    }



    $('.slideshow-content').slick({
        dots: true,
        infinite: false,
        speed: 600,
        fade: false,
        autoplay: false,
        accessibility: true
    });

    $('.phone-slideshow').slick({
        dots: false,
        infinite: true,
        speed: 400,
        fade: false,
        autoplay: true,
        accessibility: false,
        arrows: false
    });

    setTimeout(playIntro, 1500);

    $('.slimmenu').slimmenu({
        resizeWidth: '10000',
        collapserTitle: 'Main Menu',
        animSpeed: 'fast',
        indentChildren: true,
        // childrenIndenter: '&raquo;'
    });

    $('.slimmenu a.current').each(function () {
        // $(this).parent().find('>.sub-toggle:first').click();
    });

    $('.header__mobile-navigation  .hamburger').click(function () {
        $(this).toggleClass('is-active');
        $('.slimmenu').toggleClass('is-active');
        $('.header__mobile-navigation').toggleClass('is-active');
    });

    $('.header__home .hamburger').click(function () {
        $('.header__home').hide();
        $('.hiddenHeader').show();
        $('.header__mobile-navigation  .hamburger').click();
    });

    setInterval(function () {
        if ($('h1').height() != undefined) {
            // console.log($('h1').height());
            $('.content--spacer').height($('h1').height());

        }

        if ($('.content__lead').height() != undefined) {
            // console.log($('h1').height());
            $('.content--spacer').height($('.content__lead').height());
        }
        if ($(window).width() >= 920)
            $('.subnavigation').show();

        $(window).resize(function (event) {
            if ($(window).width() < 920) {
                $('.subnavigation').hide();
            } else {
                $('.subnavigation').show();
            }
        });

    }, 1);

    var scroll = new SmoothScroll('a[href*="#"]', {
        offset: 150,
        speed: 1000
    });

    $('.more--info, .close').click(function () {
        $('.popup__info').toggleClass('show');
        return false;
    });



    AOS.init({
        once: true,
        easing: 'ease-out-sine',
        offset: -200,
        delay: 600
    });


    if ($('.content__lead').length) {
        $(".subnavigation > ul").pin({
            padding: {
                top: 150
            }
        });
        // stickybits('.subnavigation', {
        //     stickyBitStickyOffset: 150
        // });
    } else {
        // $(".subnavigation > ul").pin({padding:{top:150}});
    }

    $('.accordeon h2').click(function () {
        $(this).parent().toggleClass('is-active');
    });

});